import React, { useEffect, useState, useRef, forwardRef, useImperativeHandle } from 'react';
import { Input } from 'reactstrap';
import SimpleBar from "simplebar-react";
import axios from "axios";

import { useAuth } from '../../Provider/AuthProvider';

interface SearchResult {
    id: string;
    ref: string;
    client: string;
    total_ht: string;
    total_ttc: string;
    date: string;
    status: string;
    type: string;
    invoicepdf: string;
}

type SearchOptionHandle = {
    setSearchTermRef: (term: string) => void;
};

const SearchOrderByTerm = forwardRef<SearchOptionHandle>((props, ref) => {
    const { user, order, changeOrder } = useAuth();

        const [searchTerm, setSearchTerm] = useState<string>(order ? order.ref : '');
        const [searchResults, setSearchResults] = useState<SearchResult[]>([]);
        const [isSearchLoading, setIsSearchLoading] = useState<boolean>(false);
        const inputRef = useRef<HTMLInputElement>(null);

        // Expose setSearchTermRef method to parent
        //useImperativeHandle(ref, () => ({
        //    setSearchTermRef: (term: string) => {
        //        setSearchTerm(term);
        //        setSearchResults([]);
        //        const dropdown = document.getElementById("search-dropdown") as HTMLElement;
        //        const searchOptions = document.getElementById("search-close-options") as HTMLElement;
        //        if (dropdown && searchOptions) {
        //            dropdown.classList.remove("show");
        //            searchOptions.classList.add("d-none");
        //        }
        //    }
        //}));

        // Update searchTerm when selectedOrder changes
        useEffect(() => {
            setSearchTerm(order?.ref ?? '');
            setSearchResults([]);
            const dropdown = document.getElementById("search-dropdown") as HTMLElement;
            const searchOptions = document.getElementById("search-close-options") as HTMLElement;
            if (dropdown && searchOptions && !order) {
                dropdown.classList.remove("show");
                searchOptions.classList.add("d-none");
            }
        }, [order]);




        useEffect(() => {
            const searchOptions = document.getElementById("search-close-options") as HTMLElement;
            const dropdown = document.getElementById("search-dropdown") as HTMLElement;
            const searchInput = document.getElementById("search-options") as HTMLInputElement;

            const handleSearchInput = () => {
                const inputLength = searchInput.value.length;
                if (inputLength > 0) {
                    dropdown.classList.add("show");
                    searchOptions.classList.remove("d-none");
                } else {
                    dropdown.classList.remove("show");
                    searchOptions.classList.add("d-none");
                }
            };

            searchInput.addEventListener("focus", handleSearchInput);
            searchInput.addEventListener("keyup", handleSearchInput);

            searchOptions.addEventListener("click", () => {
                searchInput.value = "";
                dropdown.classList.remove("show");
                searchOptions.classList.add("d-none");
                setSearchTerm("");
                changeOrder(null); // Clear selected result
            });

            document.body.addEventListener("click", (e: any) => {
                if (e.target.getAttribute('id') !== "search-options") {
                    dropdown.classList.remove("show");
                    searchOptions.classList.add("d-none");
                }
            });

            return () => {
                searchInput.removeEventListener("focus", handleSearchInput);
                searchInput.removeEventListener("keyup", handleSearchInput);
                searchOptions.removeEventListener("click", () => { });
                document.body.removeEventListener("click", () => { });
            };
        }, []);

        const handleSelectResult = (result: SearchResult) => {
            setSearchTerm(result.ref); // Set searchTerm to selected result's ref
            setSearchResults([]);
            changeOrder(result); // Pass selected result to parent
            if (inputRef.current) {
                inputRef.current.blur();
            }
            const dropdown = document.getElementById("search-dropdown") as HTMLElement;
            const searchOptions = document.getElementById("search-close-options") as HTMLElement;
            dropdown.classList.remove("show");
            searchOptions.classList.add("d-none");
        };

        const onKeyDownPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
            if (e.key === "Enter") {
                e.preventDefault();
                setSearchTerm((e.target as HTMLInputElement).value);
            }
        };

        const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
            event.preventDefault();
            const value = event.target.value;
            setSearchTerm(value);
            if (value === "") {
                setSearchResults([]);
            }
        };

         //Fetch search results for "commande"
        useEffect(() => {
            const delayDebounceFn = setTimeout(() => {
                if (searchTerm.length >= 3) {
                    setIsSearchLoading(true);
                    axios
                        .post(
                            "/apiV2/",
                            {
                                action: "search",
                                term: searchTerm,
                                entity: user.entity,
                            },
                            {
                                baseURL: "https://api.apapiecesauto.fr",
                                headers: {
                                    "Content-Type": "application/json",
                                    "Authorization": `Bearer ${user.token}`,
                                },
                            }
                        )
                        .then((response) => {
                            setSearchResults(response.data || []);
                        })
                        .catch((error) => {
                            console.error("Erreur lors de la recherche:", error);
                            setSearchResults([]);
                        })
                        .finally(() => {
                            setIsSearchLoading(false);
                        });
                } else {
                    setSearchResults([]);
                }
            }, 500);

            return () => clearTimeout(delayDebounceFn);
        }, [searchTerm, user.entity]);

        return (
            <React.Fragment>
                <form className="app-search d-none d-md-block">
                    <div className="position-relative dropdown-header m-3">
                        <Input
                            type="text"
                            className="form-control"
                            style={{ width: "260px" }}
                            placeholder="Rechercher une commande"
                            id="search-options"
                            value={searchTerm}
                            onKeyDown={onKeyDownPress}
                            onChange={handleChange}
                            innerRef={inputRef}
                            autoComplete="off"
                        />
                        <span className="mdi mdi-magnify search-widget-icon"></span>
                        <span
                            className="mdi mdi-close-circle search-widget-icon search-widget-icon-close d-none"
                            id="search-close-options"
                            onClick={() => {
                                setSearchTerm('');
                                setSearchResults([]);
                                changeOrder(null); // Notify Header to clear selection
                                const dropdown = document.getElementById("search-dropdown") as HTMLElement;
                                const searchOptions = document.getElementById("search-close-options") as HTMLElement;
                                if (dropdown && searchOptions) {
                                    dropdown.classList.remove("show");
                                    searchOptions.classList.add("d-none");
                                }
                            }}
                        ></span>
                    </div>
                    <div className="m-3">
                        <div className="dropdown-menu dropdown-menu-lg" id="search-dropdown" style={{ width: "260px" }}>
                            <SimpleBar style={{ height: "320px" }}>
                                {searchTerm.length >= 3 && (
                                    <>
                                        <div className="dropdown-header">
                                            <h6 className="text-overflow text-muted mb-0 text-uppercase">Résultats de la recherche</h6>
                                        </div>
                                        {isSearchLoading ? (
                                            <div className="dropdown-item py-2 text-muted">
                                                <div className="d-flex">
                                                    <div className="flex-grow-1">
                                                        <h6 className="m-0">Recherche en cours...</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        ) : searchResults.length > 0 ? (
                                            searchResults.map((result, index) => (
                                                <div
                                                    key={index}
                                                    className="dropdown-item py-2"
                                                    onClick={() => handleSelectResult(result)}
                                                    style={{ cursor: "pointer" }}
                                                >
                                                    <div className="d-flex align-items-center">
                                                        <div className="flex-grow-1">
                                                            <h6 className="m-0">{result.ref}</h6>
                                                            <span className="fs-11 mb-0 text-muted">{result.client}</span>
                                                        </div>
                                                        <div className="d-flex flex-column align-items-end">
                                                            <span className="fs-11 mb-1 text-muted">{result.date}</span>
                                                            <span
                                                                className={`badge ${result.type === "commande" ? "bg-success" : "bg-warning"}`}
                                                            >
                                                                {result.type}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <div className="dropdown-item py-2 text-muted">
                                                <div className="d-flex">
                                                    <div className="flex-grow-1">
                                                        <h6 className="m-0">Aucun résultat trouvé</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </>
                                )}
                            </SimpleBar>
                        </div>
                    </div>
                </form>
            </React.Fragment>
        );
    });

export default SearchOrderByTerm;